function init() {
    var $filterButtons = $(".filter-buttons");
    var $clearFilterButton = $(".clear-filters");
    var $clearSearchButton = $(".clear-search");
    var $selectedFilters = $(".selected-filters");

    var dataLabels = {
        categoryId: "data-category-id",
        resultType: "data-result-type",
        docType: "data-doc-type",
        languageFilter: "data-language-filter",
        videoTypeId: "data-video-type-id",
        videoCategoryId: "data-video-category-id"
    };

    var i = document.location.href.lastIndexOf("?");
    var categories = document.location.href.substr(i + 1).replace(/c=/g, "").split("&");
    var resultTypes = document.location.href.substr(i + 1).replace(/t=/g, "").split("&");
    var docTypes = document.location.href.substr(i + 1).replace(/d=/g, "").replace(/%20/g, " ").split("&");
    var languages = document.location.href.substr(i + 1).replace(/l=/g, "").split("&");
    var videoTypes = document.location.href.substr(i + 1).replace(/vt=/g, "").split("&");
    var videoCategories = document.location.href.substr(i + 1).replace(/vc=/g, "").split("&");


    // Check filters based on parameters
    $filterButtons.find(".checkbox input").prop("checked",
        function () {
            return $.inArray(this.getAttribute(dataLabels.categoryId), categories) !== -1 ||
                $.inArray(this.getAttribute(dataLabels.resultType), resultTypes) !== -1 ||
                $.inArray(this.getAttribute(dataLabels.docType), docTypes) !== -1 ||
                $.inArray(this.getAttribute(dataLabels.languageFilter), languages) !== -1 ||
                $.inArray(this.getAttribute(dataLabels.videoTypeId), videoTypes) !== -1 ||
                $.inArray(this.getAttribute(dataLabels.videoCategoryId), videoCategories) !== -1;
        });

    var checkedBoxesOnLoad = $(".checkbox input:checked");
    var checkboxes = $("input:checkbox");
    var showClearFilters = false;
    for (var l = 0; l < checkboxes.length; l++) {
        if ($(checkboxes[l]).attr("checked") == "checked") {
            showClearFilters = true;
            break;
        }
    }
    if (checkedBoxesOnLoad[0] !== null && checkedBoxesOnLoad[0] !== undefined || showClearFilters) {
        $clearFilterButton.removeClass("hidden-button");
        $clearSearchButton.removeClass("hidden-button");

        for (var j = 0; j < checkedBoxesOnLoad.length; j++) {
            var checkboxList = checkedBoxesOnLoad[j].parentNode.parentNode.parentNode;
            checkboxList.style.display = "block";

            var accordionChildren = checkboxList.parentNode.children;
            for (var k = 0; k < accordionChildren.length; k++) {
                if (accordionChildren[k].classList.contains("btn-switch") &&
                    !accordionChildren[k].classList.contains("active")) {
                    accordionChildren[k].classList.add("active");
                }
            }
        }
    }

    $selectedFilters.find("a").on("click",
        function (e) {
            e.preventDefault();
            var categoryId = this.getAttribute(dataLabels.categoryId);
            $(".checkbox input:checked").filter("[" + dataLabels.categoryId + '="' + categoryId + '"]')
                .trigger("click");

            var resultType = this.getAttribute(dataLabels.resultType);
            $(".checkbox input:checked").filter("[" + dataLabels.resultType + '="' + resultType + '"]')
                .trigger("click");

            var docType = this.getAttribute(dataLabels.docType);
            $(".checkbox input:checked").filter("[" + dataLabels.docType + '="' + docType + '"]').trigger("click");

            var languageFilter = this.getAttribute(dataLabels.languageFilter);
            $(".checkbox input:checked").filter("[" + dataLabels.languageFilter + '="' + languageFilter + '"]')
                .trigger("click");

            var videoTypeId = this.getAttribute(dataLabels.videoTypeId);
            $(".checkbox input:checked").filter("[" + dataLabels.videoTypeId + '="' + videoTypeId + '"]')
                .trigger("click");

            var videoCategoryId = this.getAttribute(dataLabels.videoCategoryId);
            $(".checkbox input:checked").filter("[" + dataLabels.videoCategoryId + '="' + videoCategoryId + '"]')
                .trigger("click");
        });

    $filterButtons.find("a").on("click",
        function (e) {
            e.preventDefault();
            if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this).next().hide("fast");
            } else {
                $(this).addClass("active");
                $(this).next().show("fast");
            }
        });

    $filterButtons.find(".checkbox").on("click",
        function (e) {
            var checkedBoxes = $(".checkbox input:checked");
            var url = window.location.pathname;
            var query = getUrlParameter("q");

            var requiredDocFilterName = "docs";
            var requiredDocFilter = "t=" + requiredDocFilterName;
            var currentCheckboxUnchecked = $(this).find("input:checkbox:not(:checked)")[0];

            var ignoreDocTypes = currentCheckboxUnchecked !== null &&
                currentCheckboxUnchecked !== undefined &&
                currentCheckboxUnchecked.getAttribute("data-result-type") === requiredDocFilterName;

            if (checkedBoxes[0] !== null && checkedBoxes[0] !== undefined) {
                url += "?";
                var appendAmp = "";
                for (var j = 0; j < checkedBoxes.length; j++) {
                    if (j > 0) appendAmp = "&";
                    if (checkedBoxes[j].getAttribute(dataLabels.categoryId)) {
                        url += appendAmp + "c=" + checkedBoxes[j].getAttribute(dataLabels.categoryId);
                    }
                    if (checkedBoxes[j].getAttribute(dataLabels.resultType)) {
                        url += appendAmp + "t=" + checkedBoxes[j].getAttribute(dataLabels.resultType);
                    }
                    if (checkedBoxes[j].getAttribute(dataLabels.docType) && !ignoreDocTypes) {
                        url += appendAmp + "d=" + checkedBoxes[j].getAttribute(dataLabels.docType);
                    }
                    if (checkedBoxes[j].getAttribute(dataLabels.languageFilter)) {
                        url += appendAmp + "l=" + checkedBoxes[j].getAttribute(dataLabels.languageFilter);
                    }
                    if (checkedBoxes[j].getAttribute(dataLabels.videoTypeId)) {
                        url += appendAmp + "vt=" + checkedBoxes[j].getAttribute(dataLabels.videoTypeId);
                    }
                    if (checkedBoxes[j].getAttribute(dataLabels.videoCategoryId)) {
                        url += appendAmp + "vc=" + checkedBoxes[j].getAttribute(dataLabels.videoCategoryId);
                    }
                }

                if (url.indexOf("d=") !== -1 && url.indexOf(requiredDocFilter) === -1) {
                    url += "&" + requiredDocFilter;
                }

                if (query) {
                    url += "&q=" + query;
                }
            } else if (query) {
                url += "?q=" + query;
            }
            window.location.href = url;
        });

    $clearFilterButton.on("click",
        function (e) {
            $(".checkbox input:checked").removeAttr("checked");
            var url = window.location.pathname;
            var query = getUrlParameter("q");
            if (query) {
                url += "?q=" + query;
            }
            if (window.covid19) {
                url += "?" + "vt=" + 0;
            }
            window.location.href = url;
        });

    $clearSearchButton.on("click",
        function (e) {
            $(".checkbox input:checked").removeAttr("checked");
            window.location.href = window.location.pathname;
        });
}

function getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

export default {
    init
}